export const RESET = 'EXCMDEVICETYPE_LIST_RESET'
export const SET_ITEMS = 'EXCMDEVICETYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDEVICETYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDEVICETYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDEVICETYPE_LIST_TOGGLE_LOADING'
